import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import { Route/* , Redirect */ } from 'react-router-dom';

export const PublicRoute = ({ sAuthenticated, component: Component, ...rest }) => (
  <Route {...rest} component={(props) => (
    /* isAuthenticated ? (
        <Redirect to="/home" />
    ) : ( */
      <Fragment>
        <Component {...props} />
      </Fragment>
      /*  ) */
  )} />
);

/* const mapStateToProps = (state) => ({
  isAuthenticated: !!state.auth.uid
}); */

export default connect(/* mapStateToProps */)(PublicRoute);


